import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, signInWithCustomToken, signOut, type Auth } from 'firebase/auth';
import { getDatabase, type Database } from 'firebase/database';
import type { FirebaseTokenResponse } from './types';

let app: FirebaseApp | undefined;
let auth: Auth | undefined;
let database: Database | undefined;

function ensureApp(databaseURL: string): FirebaseApp {
  if (app) return app;
  const existing = getApps();
  if (existing.length) {
    app = existing[0];
    return app;
  }
  app = initializeApp({
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    databaseURL,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  });
  return app;
}

export async function connectFirebase(tokenResp: FirebaseTokenResponse): Promise<{
  database: Database;
  auth: Auth;
}> {
  const a = ensureApp(tokenResp.config.database_url);
  if (!auth) auth = getAuth(a);
  if (!database) database = getDatabase(a, tokenResp.config.database_url);
  await signInWithCustomToken(auth, tokenResp.firebase_token);
  return { database, auth };
}

export async function signOutFirebase(): Promise<void> {
  if (auth) {
    try {
      await signOut(auth);
    } catch {
      // best-effort
    }
  }
}
